<template lang="pug">
button.ladda-button.btn(ref="laddaRef" :class="'btn-' + variant" :data-style="dataStyle" :disabled="props.disabled" @click="(e) => emit('click', e)")
  span.ladda-label
    slot Submit
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { type LaddaButton, create } from 'ladda/js/ladda';

const props = withDefaults(
  defineProps<{
    dataStyle?: string;
    isLoading?: boolean;
    progress?: number;
    variant?: string;
    disabled?: boolean;
  }>(),
  {
    dataStyle: 'expand-left',
    isLoading: true,
    progress: 0,
    variant: 'primary',
    disabled: false
  }
);

const emit = defineEmits(['click']);

const laddaRef = ref<HTMLButtonElement | null>(null);
const ladda = ref<LaddaButton | null>(null);

watch(
  () => props.isLoading,
  () => {
    props.isLoading ? ladda.value!.start() : ladda.value!.stop();
    laddaRef.value!.disabled = props.disabled;
  }
);

watch(
  () => props.progress,
  () => {
    ladda.value!.setProgress(props.progress);
  }
);

onBeforeUnmount(() => {
  ladda.value?.remove();
  ladda.value = null;
});

onMounted(() => {
  ladda.value = create(laddaRef.value! as HTMLButtonElement);
  props.isLoading ? ladda.value.start() : ladda.value.stop();
});
</script>

<style lang="scss">
// TODO: make themed a option?
@use 'ladda/css/ladda.scss';
</style>
